module.exports = __webpack_public_path__ + "img/no.bc301d7a.png";